import axios from "axios";
import { base_url } from "../../config";
import React, { useEffect, useState } from "react";
import LoginModal from "../main/loginModal/LoginModal";
import { Link, useNavigate } from "react-router-dom";

function MobileProfile() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [userProfile, setUserProfile] = useState();
  const [editProfileClicked, setEditProfileCliked] = useState(false);

  const accessToken = localStorage.getItem("@user");

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(`${base_url}/profile-members/profile`, {
          headers: { authorization: `Bearer ${accessToken}` },
        });

        // console.log("Profile Data:", response.data.data);
        setUserProfile(response.data.data);
      } catch (error) {
        console.error("Failed to fetch profile data:", error);
      }
    };

    fetchProfileData();
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    // Check screen width
    if (window.innerWidth > 768) {
      // Redirect to "/" if on desktop
      navigate("/");
    }
  }, [navigate]);

  const [isVisible, setIsVisible] = useState(accessToken ? false : true);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []); // Run on mount

  return (
    <section className="mobile-my-profile-section">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <div
        id="w-node-d4808272-3798-91fb-d7eb-2855abae5142-6573989e"
        className="my-profile-page"
      >
        <h3 className="heading-8">My Account</h3>
        <a
          href="/profile/myprofile"
          className="my-pfole-image-flex w-inline-block"
        >
          <div className="my-profle-image-section">
            <div className="review-five-user">
              {userProfile?.photo ? (
                <img className="user-profile-pic" src={userProfile?.photo} />
              ) : (
                <img
                  className="user-profile-pic"
                  src="../../static/media/user-icon-1.62f73db9586c0e3b573a.svg"
                />
              )}
            </div>
            <div className="review_details-content">
              <div className="margin-bottom margin-xxsmall">
                <h6 className="heading-6">{userProfile?.first_name}</h6>
              </div>
              <div className="margin-bottom">
                <div className="date-text">
                  {" "}
                  {userProfile?.gender && <>{userProfile?.gender}</>}
                  {/* {userProfile?.age > 0 ? (
                    <>&nbsp;&nbsp;{userProfile.age} Years Old</>
                  ) : (
                    <>Forever a mystery</>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <div className="my-profile-arrow">
            <div className="code-embed-9 w-embed">
              <svg
                fill="currentColor"
                height="100%"
                width="100%"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 330 330"
                xmlSpace="preserve"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="SVGRepo_iconCarrier">
                  <path
                    id="XMLID_222_"
                    d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"
                  />
                </g>
              </svg>
            </div>
          </div>
        </a>
      </div>
      {localStorage.getItem("userType") !== "NO_HOST" && (
        <div
          id="w-node-_7206a05e-af14-7a8c-7bab-ef116519c47b-6573989e"
          className="my-profile-page"
        >
          <a
            href="mailto:support@hightable.ai"
            className="float-a-table-btn w-inline-block"
          >
            <div className="my-profle-image-section">
              <div className="review_details-content-copy">
                <div className="margin-bottom margin-xxsmall">
                  <h6 className="heading-6">Float a Table</h6>
                </div>
                <div className="margin-bottom">
                  <div className="date-text">
                    One click to float, a million memories to cherish.
                  </div>
                </div>
              </div>
            </div>
            <div className="float-a-table-image">
              <img
                src="images/hightable-256.png"
                loading="lazy"
                alt=""
                className="user-profile-pic"
              />
            </div>
          </a>
        </div>
      )}

      <div
        id="w-node-_7d7a6fe2-d1c3-7a08-77d6-faa55de6378f-6573989e"
        className="my-profile-page"
      >
        <a
          href="/profile/myprofile"
          className="my-pfole-image-flex w-inline-block"
        >
          <div className="my-profle-image-section">
            <div className="review_details-content">
              <div className="margin-bottom margin-xxsmall">
                <h6 className="heading-6">My Bookings</h6>
              </div>
            </div>
          </div>
          <div className="my-profile-arrow">
            <div className="code-embed-9 w-embed">
              <svg
                fill="currentColor"
                height="100%"
                width="100%"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 330 330"
                xmlSpace="preserve"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="SVGRepo_iconCarrier">
                  <path
                    id="XMLID_222_"
                    d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"
                  />
                </g>
              </svg>
            </div>
          </div>
        </a>
      </div>
      <div
        id="w-node-_1c24ed1e-6934-e3ea-90f4-1e37189644dc-6573989e"
        className="my-profile-page"
      >
        <a
          href="mailto:support@hightable.ai"
          className="my-pfole-my-bookings w-inline-block"
        >
          <div className="my-profle-image-section">
            <div className="review_details-content">
              <div className="margin-bottom margin-xxsmall">
                <h6 className="heading-6">Help</h6>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        id="w-node-e23e17c9-295a-793e-3b05-395b9ffc9b4d-6573989e"
        className="my-profile-page"
      >
        <a href="#" className="my-pfole-my-bookings w-inline-block">
          <div
            className="my-profle-image-section"
            onClick={() => {
              localStorage.removeItem("@user");
              localStorage.removeItem("@userRefreshToken");
              localStorage.removeItem("@userName");
              localStorage.removeItem("@userPhone");
              localStorage.removeItem("@userAccount");
              localStorage.removeItem("@userPhoto");
              localStorage.clear();
              navigate(`/`);
              window.location.reload();
            }}
          >
            <div className="review_details-content">
              <div className="margin-bottom margin-xxsmall">
                <h6 className="logout-text">Logout</h6>
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}

export default MobileProfile;
